import servicio from '@/services/servicio-base'

const servicioCatalogo = {}

servicioCatalogo.buscar =  params => {
    //console.log('params', params)
     return servicio.post('/catalogo-general/buscar', params)
     .then(r => {
         return r.data
     })
     .catch(error => {
         return error
     })
}


servicioCatalogo.buscarFormasFarmaceuticas = params => {
    return servicio.get(`/catalogo-general/buscar/formas-farmaceuticas/${params.generico}/${params.tipoFormula}`)
    .then(r => {
        return r.data;
    })
    .catch(error => {
        return error;
    })
}

servicioCatalogo.buscarFormulas = params => {
    return servicio.get(`/catalogo-general/buscar/formulas/${params.generico}/${params.tipoFormula}/${params.codFormaFarmaceutica}`)
    .then(r => {
        return r.data;
    })
    .catch(error => {
        return error;
    })
}

servicioCatalogo.buscarContenidoVenta = params => {
    return servicio.get(`/catalogo-general/buscar/contenido-venta/${params.generico}/${params.tipoFormula}/${params.codFormaFarmaceutica}/${params.codFormula}`)
    .then(r => {
        return r.data;
    })
    .catch(error => {
        return error;
    })
}

servicioCatalogo.consultarDescripcionArticulos = function(codArticulo) {
    return servicio.get(`/catalogo-general/buscar/descripcion-articulos/${codArticulo}`)
    .then(r => {
        return r.data;
    })
    .catch(error => {
        return error;
    })
}

servicioCatalogo.revisarEsBuenFin = function() {
    return servicio.get('/catalogo-general/buscar/buen-fin')
    .then(r => {
        return r.data;
    })
    .catch(error => {
        return error;
    })
}

export default servicioCatalogo